"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dncAlert: 'This contact is on a Do Not Call list.'
};
exports["default"] = _default;
//# sourceMappingURL=en-US.js.map
